import React from "react";
import styles from "./Page01.module.scss";
import { useBlocks } from "@jelly/lesson";

type singleBlockData = {
  header: string;
  name: string;
  image?: string;
  samples: Array<{ title: string; src: string }>;
};

export interface Lesson0209Page01Props {
  infoBoxText?: string;

  example1: singleBlockData;
  example2: singleBlockData;
}

export const Lesson0209Page01: React.FC<Lesson0209Page01Props> = (props) => {
  const block = useBlocks();

  function renderBlock(data: singleBlockData): React.ReactNode {
    return (
      <div className={styles.blockWrapper}>
        {data?.image && (
          <div className={styles.imageWrapper}>
            <img src={data.image} alt={data.name} />
          </div>
        )}
        <div className={styles.descriptionWrapper}>
          <p>{data.header}</p>
          <h2>{data.name}</h2>
        </div>

        <div className={styles.audioWrapper}>
          {data.samples.map((sample, index) => (
            <block.audioButton
              key={`audio_button_1_${index}`}
              text={sample.title}
              url={sample.src}
              icon="cis-volume-high"
              theme="secondary"
              shape="round"
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pageWrapper}>
      {props.infoBoxText && (
        <div className={styles.infoBoxWrapper}>
          <block.infoBox text={props.infoBoxText} icon="cil-headphones" compact={true} />
        </div>
      )}

      <div className={styles.blocksWrapper}>
        {renderBlock(props.example1)}
        <div className={styles.verticalLine}></div>
        {renderBlock(props.example2)}
      </div>
    </div>
  );
};
